import { SidebarRouteType } from '~components/layout/sidebar/lessor-sidebar-routes';

import { ROUTES } from '~app/router/routes';

import { ReactComponent as IconBanknote } from '~assets/icons/icon-banknote.svg';
import { ReactComponent as IconBell } from '~assets/icons/icon-bell.svg';
import { ReactComponent as IconBill } from '~assets/icons/icon-bill.svg';
import { ReactComponent as IconContract2 } from '~assets/icons/icon-contract-2.svg';
import { ReactComponent as IconDashboard } from '~assets/icons/icon-dashboard.svg';
import { ReactComponent as IconMessageSquareText } from '~assets/icons/icon-message-square-text.svg';

export const tenantSidebarLinks: SidebarRouteType[] = [
  {
    label: 'Головна',
    route: ROUTES.TENANT_SCOPE,
    icon: IconDashboard,
    heading: false,
    subRoutes: null,
    access: null,
  },
  {
    label: 'Оренда',
    icon: null,
    access: null,
    heading: true,
    subRoutes: [
      // {
      //   label: 'Нерухомість',
      //   route: ROUTES.TENANT_PROPERTIES,
      //   icon: IconBuilding1,
      //   access: null,
      //   subRoutes: null,
      // },
      {
        label: 'Договори оренди',
        route: ROUTES.TENANT_LEASES,
        icon: IconContract2,
        access: null,
        subRoutes: null,
        heading: false,
      },
      {
        label: 'Нагадування',
        route: ROUTES.TENANT_REMINDERS,
        icon: IconBell,
        access: null,
        subRoutes: null,
        heading: false,
      },
    ],
  },

  {
    label: 'Фінанси',
    icon: null,
    access: null,
    heading: true,
    subRoutes: [
      {
        label: 'Рахунки',
        route: ROUTES.TENANT_INVOICES,
        icon: IconBill,
        access: null,
        subRoutes: null,
        heading: false,
      },
      {
        label: 'Платежі',
        route: ROUTES.TENANT_PAYMENTS,
        icon: IconBanknote,
        access: null,
        subRoutes: null,
        heading: false,
      },
    ],
  },
  {
    label: 'Допомога',
    icon: null,
    access: null,
    heading: true,
    subRoutes: [
      {
        label: 'Служба турботи',
        route: ROUTES.TENANT_SUPPORT,
        icon: IconMessageSquareText,
        access: null,
        subRoutes: null,
        heading: false,
      },
    ],
  },
];
